export default __webpack_public_path__ + "static/media/ContractFirstViewIcon.d81057a8.svg";